(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@aws-amplify/core"), require("graphql"), require("@aws-amplify/auth"), require("@aws-amplify/cache"));
	else if(typeof define === 'function' && define.amd)
		define("aws_amplify_pubsub", ["@aws-amplify/core", "graphql", "@aws-amplify/auth", "@aws-amplify/cache"], factory);
	else if(typeof exports === 'object')
		exports["aws_amplify_pubsub"] = factory(require("@aws-amplify/core"), require("graphql"), require("@aws-amplify/auth"), require("@aws-amplify/cache"));
	else
		root["aws_amplify_pubsub"] = factory(root["@aws-amplify/core"], root["graphql"], root["@aws-amplify/auth"], root["@aws-amplify/cache"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__1__, __WEBPACK_EXTERNAL_MODULE__5__, __WEBPACK_EXTERNAL_MODULE__11__) {
return 